import { defineComponent } from 'vue'
import { debounce } from 'lodash'
import { first } from 'rxjs/operators'
import { faCircleNotch, faUndo } from '@fortawesome/free-solid-svg-icons'

import { Item, MovementTypes } from '@skinsoft/types'
import { ItemDataStore } from '@skinsoft/entity'
import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { ItemCard } from "../../item-card"
import { BarcodeReader, BarcodeSubscriber } from "../../barcode"

export interface Values {
    location: string;
    identifier: string
}

export const AddAccessoryForm = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBarcodeReader: BarcodeReader,
        sBarcodeSubscriber: BarcodeSubscriber,
        sItemCard: ItemCard
    },
    template: require('./add-accessory-form.html'),
    data() {
        return {
            // Bug: canChainAdd is passed by the parent template but never declared as a `prop` here,
            // so it isn't reactive to parent updates — needs a proper `props` entry.
            canChainAdd: undefined as boolean | undefined,
            accessory: null as any as Item,

            MovementTypes,

            searchPending: false,
            debounce,
            errorMessage: '',
            submitting: false,

            INPUT_FILTER_IDENTIFIER: 'add-item-search-query-input',

            undoIcon: faUndo,
            loadingIcon: faCircleNotch,
        }
    },
    methods: {
        async validate(values): Promise<any> {
            const errors = {} as any
            const errorMessage = this.$t('entity.addItem.form.id.notFoundError') as string

            if (!values.id) {
                this.errorMessage = this.$t('entity.addItem.from.id.emptyError') as string
            }

            if (values.id) {
                try {
                    this.searchPending = true
                    const matchingSearchResult = await this.$itemDataStore.searchOneWithText(values.id, ['physicalAccessoryItem', 'numericAccessoryItem'])
                    const searchResultId = ItemDataStore.getItemSearchResultId(matchingSearchResult)

                    this.accessory = await this.$itemDataStore.fetchOne(searchResultId).pipe(first()).toPromise()
                    const form = (this.$refs.form as any).form
                    // @ts-ignore
                    form.getState().values.itemId = this.accessory.id
                    // @ts-ignore
                    form.getState().values.itemType = this.accessory.type

                    this.searchPending = false
                } catch(error) {
                    this.searchPending = false
                    this.errorMessage = errorMessage
                    this.accessory = null as any
                }
            }

            return errors
        },

        onBarcodeReaderInput(input: string) {
            const form = (this.$refs.form as any).form

            form.batch(() => {
                const fieldName = 'id'
                form.change(fieldName, input)
                form.mutators.setFieldTouched(fieldName, true)
            })
        },

        resetSearch() {
            this.accessory = null as any
            const form = (this.$refs.form as any).form
            const fieldName = 'id'
            form.change(fieldName, '')
            form.mutators.setFieldTouched(fieldName, true)
            this.searchPending = false
        },

        validateSelection() {
            this.$emit('accessory-selected', this.accessory)
            if (this.canChainAdd) {
                this.resetSearch()
            } else {
                this.submitting = true
            }
        },
    },
})
